import { DeepPartial } from '../../../core/models';
import { IAncestor, IAncestorItem } from '../../../core/models/ancestor';
import {
  ExerciseType,
  IExercise,
  IExerciseAlternative,
} from '../../../core/models/exercise';
import { getDisciplineName } from '../../../core/utils/discipline';

export const normalizeExercises = (exercises: DeepPartial<IExercise>[]) => {
  if (exercises && exercises.length > 0) {
    const newExercises = exercises.map((it) => {
      console.log("ite =>", it)
      const alternatives = it.alternatives
        ? it.alternatives?.map((item) => {
            return {
              text: item?.text || '',
              correction: false,
              alternativeId: '',
              id: item?._id || item?.id || '',
              _id: item?._id || item?.id || '',
            };
          })
        : ([
            {
              text: '',
              correction: false,
              alternativeId: '',
              id: '',
              _id: '',
            },
          ] as IExerciseAlternative[]);

      const ancestors = it.ancestors
        ? ({
            area: {
              id: it.ancestors.area?.id || '',
              slug: it.ancestors.area?.slug || '',
            } as IAncestorItem,
            level: {
              id: it.ancestors.level?.id || '',
              slug: it.ancestors.level?.slug || '',
            } as IAncestorItem,
            subarea: {
              id: it.ancestors.subarea?.id || '',
              slug: it.ancestors.subarea?.slug || '',
            } as IAncestorItem,
            _id: it.ancestors._id || '',
          } as IAncestor)
        : ({
            area: { id: '', slug: '' },
            level: { id: '', slug: '' },
            subarea: { id: '', slug: '' },
            _id: '',
          } as IAncestor);

      return {
        alternatives: alternatives,
        ancestors: ancestors,
        exerciseType: (it.exercise_type as ExerciseType) || 'discursive',
        slug: it.slug || '',
        statement: it.statement || '',
        title: it.title || '',
        id: it._id || it.id || '',
        _id: it._id || it.id || '',
        exercise_type: (it.exercise_type as ExerciseType) || 'discursive',
        question_type: (it.exercise_type as ExerciseType) || 'discursive',
        favorite: false,
        resolution: '',
        correctPercentage: null,
        done: false,
        correct: false,
        area: it.ancestors?.area?.slug
          ? getDisciplineName(it.ancestors?.area?.slug)
          : '',
        order: { subarea: 999 },
        paid: false,
        subjects: [],
        totalAnswersCalculated: 0,
        createdAt: new Date('2024-01-01 00:00:00'),
        difficulty: '',
        display: true,
        institution: '',
        lastCorrectPercentageCalculus: new Date('2024-01-01 00:00:00'),
        lastCorrectReviewsCalculus: new Date('2024-01-01 00:00:00'),
        percentDislikes: 0,
        percentLikes: 0,
        totalDislikes: 0,
        totalFeedbacks: 0,
        totalLikes: 0,
        updatedAt: new Date('2024-01-01 00:00:00'),
        year: 2024,
        answered: false,
        status: 'incorrect' as 'correct' | 'incorrect',
        text: '',
        questionId: it._id || it.id || '',
        __v: 1,
      };
    });

    return newExercises;
  }

  return [];
};
